<template>
  <div class="map-wrapper">
    <iframe :src="url" width="100%" height="100%" frameborder="0" style="border:0" allowfullscreen>
    </iframe>
  </div>
</template>
<script>
  export default {
    props: ['url']
  }
</script>
<style lang="stylus">
.map-wrapper
  height: 100%
  width: 100%
  position: relative
</style>



// WEBPACK FOOTER //
// MapWrapper.vue?9f784662